// Simplified inline SVG flags (emoji flags don't render on Windows)
export const FLAGS = {
  usa: (
    <svg viewBox="0 0 19 13" className="h-[11px] w-4 rounded-[1px] shrink-0" aria-hidden="true">
      <rect width="19" height="13" fill="#B31942" />
      {[1, 3, 5, 7, 9, 11].map((y) => (
        <rect key={y} y={y} width="19" height="1" fill="#FFFFFF" />
      ))}
      <rect width="8" height="7" fill="#0A3161" />
    </svg>
  ),
  canada: (
    <svg viewBox="0 0 19 13" className="h-[11px] w-4 rounded-[1px] shrink-0" aria-hidden="true">
      <rect width="19" height="13" fill="#FFFFFF" />
      <rect width="5" height="13" fill="#D80621" />
      <rect x="14" width="5" height="13" fill="#D80621" />
      <path d="M9.5 2.6 L10.5 4.7 L11.9 4.3 L11.2 6.1 L12.5 6.8 L10.9 7.2 L10.9 9.4 L8.1 9.4 L8.1 7.2 L6.5 6.8 L7.8 6.1 L7.1 4.3 L8.5 4.7 Z" fill="#D80621" />
    </svg>
  ),
  uk: (
    <svg viewBox="0 0 19 13" className="h-[11px] w-4 rounded-[1px] shrink-0" aria-hidden="true">
      <rect width="19" height="13" fill="#012169" />
      <path d="M0 0 L19 13 M19 0 L0 13" stroke="#FFFFFF" strokeWidth="2.6" />
      <path d="M0 0 L19 13 M19 0 L0 13" stroke="#C8102E" strokeWidth="1.1" />
      <path d="M9.5 0 V13 M0 6.5 H19" stroke="#FFFFFF" strokeWidth="4" />
      <path d="M9.5 0 V13 M0 6.5 H19" stroke="#C8102E" strokeWidth="2.3" />
    </svg>
  ),
  australia: (
    <svg viewBox="0 0 19 13" className="h-[11px] w-4 rounded-[1px] shrink-0" aria-hidden="true">
      <rect width="19" height="13" fill="#00008B" />
      <path d="M0 0 L9 6 M9 0 L0 6" stroke="#FFFFFF" strokeWidth="1.2" />
      <path d="M0 0 L9 6 M9 0 L0 6" stroke="#C8102E" strokeWidth="0.5" />
      <path d="M4.5 0 V6 M0 3 H9" stroke="#FFFFFF" strokeWidth="1.8" />
      <path d="M4.5 0 V6 M0 3 H9" stroke="#C8102E" strokeWidth="1" />
      <circle cx="14" cy="3.2" r="0.8" fill="#FFFFFF" />
      <circle cx="14" cy="9.4" r="0.8" fill="#FFFFFF" />
      <circle cx="11.8" cy="6.4" r="0.8" fill="#FFFFFF" />
      <circle cx="16.2" cy="6.4" r="0.8" fill="#FFFFFF" />
      <circle cx="4.5" cy="9.6" r="1" fill="#FFFFFF" />
    </svg>
  ),
};
